/* eslint-disable react/jsx-no-bind */
/* eslint-disable id-length */
import { twMerge } from "tailwind-merge";
import classNames from "classnames";
import { CommandJob } from "app/components/build/Show/lib/types";
import { Link } from "react-router-dom";
import { resolveJobUrl } from "app/components/build/Show/lib/urlForView";

interface Props {
  jobs: CommandJob[];
}

export function Jobs({ jobs }: Props) {
  const passCount = jobs.filter((job) => job.passed).length;
  const totalCount = jobs.length;
  const { rows, columns } = gridSizeForJobCount(jobs.length);

  return (
    <>
      <div
        className="grid gap-1"
        style={{
          gridTemplateRows: `repeat(${rows}, minmax(0, 1fr))`,
          gridTemplateColumns: `repeat(${columns}, minmax(25px, 10%))`,
        }}
      >
        {jobs.map((job) => {
          return (
            <Link
              data-testid="parallel-job-link"
              onClick={(e) => e.stopPropagation()}
              to={Features.BuildSidebar ? resolveJobUrl(job.id) : job.path}
              key={job.id}
              className={twMerge(
                "border border-slate-500 h-2 bg-white rounded-sm transition-colors",
                classNames({
                  "border-lime-500": job.state === "finished" && job.passed,
                  "border-red-500 bg-red-500": job.state === "finished" && !job.passed,
                  "border-orange-500": job.state === "running",
                }),
              )}
            />
          );
        })}
      </div>
      <div>
        <span className="text-charcoal-300">
          {passCount} of {totalCount} passed
        </span>
      </div>
    </>
  );
}

// Calculate the CSS grid size for a given number of jobs
const gridSizeForJobCount = (jobCount: number, maxColumnSize = 10) => {
  const rows = Math.ceil(jobCount / maxColumnSize);
  const columns = Math.min(jobCount, maxColumnSize);

  return { rows, columns };
};
